import { useEffect, useState } from "react";

export default function SimplePay() {
  const [paddleReady, setPaddleReady] = useState(false);

  useEffect(() => {
    // Load Paddle script
    const script = document.createElement("script");
    script.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
    script.async = true;
    script.onload = () => {
      if (window.Paddle) {
        window.Paddle.Environment.set("sandbox"); // Set environment

        // Initialize with token (for client-side checkout)
        window.Paddle.Initialize({
          token: "test_21d1cf74b8f979932dc60c53517", // replace with your test token
          eventCallback: (data) => {
            console.log("Paddle event:", data);
          },
        });

        setPaddleReady(true);
      }
    };
    document.body.appendChild(script);
  }, []);

  const handleCheckout = () => {
    if (!window.Paddle || !paddleReady) return;

    // Define items
    const items = [{ priceId: "pri_01jvvbxgfsfbyvgagftbbt8m25", quantity: 1 }];

    // Define customer info
    const customer = {
      email: "sam@example.com",
      address: {
        countryCode: "US",
        postalCode: "10021",
      },
    };

    // Open Paddle Checkout
    window.Paddle.Checkout.open({
      items,
      customer,
    });
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Paddle Checkout (React)</h2>
      <button onClick={handleCheckout} disabled={!paddleReady}>
        {paddleReady ? "Launch Checkout" : "Loading Paddle..."}
      </button>
    </div>
  );
}
